"use strict";

require("core-js/modules/es6.array.filter.js");

var _Object$keys = require("@babel/runtime-corejs2/core-js/object/keys");

var _Object$getOwnPropertySymbols = require("@babel/runtime-corejs2/core-js/object/get-own-property-symbols");

var _Object$getOwnPropertyDescriptor = require("@babel/runtime-corejs2/core-js/object/get-own-property-descriptor");

var _Object$getOwnPropertyDescriptors = require("@babel/runtime-corejs2/core-js/object/get-own-property-descriptors");

var _Object$defineProperties = require("@babel/runtime-corejs2/core-js/object/define-properties");

var _Object$defineProperty = require("@babel/runtime-corejs2/core-js/object/define-property");

var _interopRequireDefault = require("@babel/runtime-corejs2/helpers/interopRequireDefault");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/extends"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/defineProperty"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/objectWithoutProperties"));

require("core-js/modules/es6.function.bind.js");

var _newArrowCheck2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/newArrowCheck"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _reactComponents = require("@ucloud-fe/react-components");

var _Typography = _interopRequireDefault(require("../Typography"));

var _excluded = ["children", "popup", "contentStyle", "tipStyle"];

var _this = void 0;

function ownKeys(object, enumerableOnly) { var keys = _Object$keys(object); if (_Object$getOwnPropertySymbols) { var symbols = _Object$getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return _Object$getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0, _defineProperty2["default"])(target, key, source[key]); }); } else if (_Object$getOwnPropertyDescriptors) { _Object$defineProperties(target, _Object$getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { _Object$defineProperty(target, key, _Object$getOwnPropertyDescriptor(source, key)); }); } } return target; }

/**
 * Hovertip
 * @description 鼠标移入悬停提示
 */
var Hovertip = function Hovertip(_ref) {
  var _this2 = this;

  (0, _newArrowCheck2["default"])(this, _this);
  var children = _ref.children,
      popup = _ref.popup,
      contentStyle = _ref.contentStyle,
      tipStyle = _ref.tipStyle,
      others = (0, _objectWithoutProperties2["default"])(_ref, _excluded);
  return /*#__PURE__*/_react["default"].createElement(_reactComponents.Tooltip, (0, _extends2["default"])({
    placement: "top",
    popup: /*#__PURE__*/_react["default"].createElement(_Typography["default"], {
      size: "sm",
      style: tipStyle
    }, popup),
    getPopupContainer: function () {
      (0, _newArrowCheck2["default"])(this, _this2);
      return document.body;
    }.bind(this)
  }, others), /*#__PURE__*/_react["default"].createElement("div", {
    style: _objectSpread({
      display: "inline-block",
      cursor: "pointer"
    }, contentStyle)
  }, children));
}.bind(void 0);

Hovertip.propTypes = {
  /**
   * 弹出层内容
   */
  popup: _propTypes["default"].node,

  /**
   * 内容部分样式
   */
  contentStyle: _propTypes["default"].object,

  /**
   * 提示部分样式
   */
  tipStyle: _propTypes["default"].object,
  children: _propTypes["default"].node
};
Hovertip.defaultProps = {
  contentStyle: {},
  tipStyle: {}
};
var _default = Hovertip;
exports["default"] = _default;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@ucloud/ui-components/lib/components/Hovertip/Hovertip.js
// module id = 2094
// module chunks = 6 7 17 18